<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/parentList' }">
					<i class="el-icon-lx-group"></i> 家长管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>添加家长</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">
				<el-row>
					<el-col :span="24">
						<el-form-item :label="'头像'" prop="haaPHOT">
							<el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImg">
								<el-image v-if="ruleForm.haaPHOT" fit="fill" disabled :src="ruleForm.haaPHOT" class="avatar"></el-image>
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>

					<el-col :span="8">
						<el-form-item :label="'姓名'" prop="haaNAME">
							<el-input v-model="ruleForm.haaNAME" :placeholder="'请输入姓名'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="'手机系统'" prop="haaDEFG">
							<el-radio-group v-model="ruleForm.haaDEFG">
								<el-radio label="1">Android</el-radio>
								<el-radio label="0">IOS</el-radio>
							</el-radio-group>
						</el-form-item>
						
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'手机号码'" prop="haaPHON">
							<el-input v-model="ruleForm.haaPHON" :placeholder="'请输入手机号码'"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="'登录密码'" prop="haaPSWD">
							<el-input type="password" auto-complete="new-password" v-model="ruleForm.haaPSWD" :placeholder="'请输入密码'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'生日'" prop="haaBIRT" class="font">
							<el-date-picker v-model="ruleForm.haaBIRT" type="date" :placeholder="'请选择日期'" value-format="yyyy/MM/dd" align="center"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="14">
						<el-form-item :label="'性别'" prop="haaGSEX">
							<el-radio-group v-model="ruleForm.haaGSEX">
								<el-radio label="1">男</el-radio>
								<el-radio label="0">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'昵称'" prop="haaNICK" v-if="false">
							<el-input v-model="ruleForm.haaNICK" :placeholder="'请输入昵称'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="'推送ID'" prop="haaPHID" v-if="false">
							<el-input v-model="ruleForm.haaPHID" :placeholder="'请输入推送ID'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'微信ID'" prop="haaWXID" v-if="false">
							<el-input v-model="ruleForm.haaWXID" :placeholder="'请输入微信ID'"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="'苹果ID'" prop="haaAPID" v-if="false">
							<el-input v-model="ruleForm.haaAPID" :placeholder="'请输入苹果ID'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<!-- vueCropper 剪裁图片实现-->
			<el-dialog :title="'剪裁图片'" :visible.sync="imgCutVisible" append-to-body>
				<div class="cropper-content">
					<div class="cropper" style="text-align:center">
						<vueCropper ref="cropper" :img="imgCutOption.img" :outputSize="imgCutOption.size" :outputType="imgCutOption.outputType"
						 :info="true" :full="imgCutOption.full" :canMove="imgCutOption.canMove" :canMoveBox="imgCutOption.canMoveBox"
						 :original="imgCutOption.original" :autoCrop="imgCutOption.autoCrop" :fixed="imgCutOption.fixed" :fixedNumber="imgCutOption.fixedNumber"
						 :centerBox="imgCutOption.centerBox" :infoTrue="imgCutOption.infoTrue" :fixedBox="imgCutOption.fixedBox"></vueCropper>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="imgCutVisible = false">返回</el-button>
					<el-button type="primary" @click="finish">提交</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addParent',
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					callback();
				}
			}
			const checkPhone = (rule, value, callback) => {
				if (!(/^1[34578]\d{9}$/.test(value))) {
					callback(new Error('请输入正确的手机号码'));
				}
				else {
				 	this.checkHAAPHONE(value);
					
				 	if (this.isRepeat == true) {
				 		callback(new Error('手机号码已存在'));
				 	} else {
				 		callback();
				 	}
				 }
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				imgCutVisible: false,
				imgCutOption: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				isRepeat: false,
				ruleForm: {
					haaPHON: '',
					haaPSWD: '',
					haaDEFG: '1',
					haaPHID: '',
					haaWXID: '',
					haaAPID: '',
					haaNAME: '',
					haaNICK: '',
					haaPHOT: '',
					imgbase64: '',
					haaGSEX: '1',
					haaBIRT: '',
					optionsGSEX: [],
					optionsDEFG: []
				},
				rules: {
					// haaNAME: [{
					// 	validator: validateFontSize
					// }],
					// haaNICK: [{
					// 	validator: validateFontSize
					// }],
					haaPHON: [{
						required: true,
						//message: '请输入正确的手机号码',
						trigger: ['blur', 'change'],
						validator: checkPhone
					}],
					haaPSWD: [{
						required: true,
						message: '请输入密码',
						trigger: ['blur']
					}, {
						min: 6,
						max: 18,
						message: '密码长度在 6 到 18 位之间' //密码长度在 6 到 18 位之间
					}, {
						pattern: /^(\w){6,18}$/,
						message: '只能输入6-18个字母、数字、下划线' //只能输入6-18个字母、数字、下划线
					}, ],

				}
			};
		},
		created() {},
		methods: {
			checkHAAPHONE(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcHAA.svc/CHECK_HAA_PHONE';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sHAAPHON: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeat = true;
					} else {
						this.isRepeat = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//上传头像
			uploadImg(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传产品图片大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}

				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						// that.ruleForm.imageUrl = this.result;
						// that.ruleForm.imgbase64 = this.result.split(',')[1];
						that.imgCutOption.img = this.result;
						that.imgCutVisible = true;
					}
				}
			},
			// 剪切图片确定方法
			finish() {
				this.$refs.cropper.getCropBlob((data) => {
					var reader = new FileReader();
					reader.readAsDataURL(data);
					var that = this;
					reader.onload = function(e) {
						that.ruleForm.haaPHOT = this.result;
						that.ruleForm.imgbase64 = this.result;
						that.imgCutVisible = false;
					}
				})
			},
			//家长新增
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const self = this;
						var postUrl = 'WCF/WEB/svcHAA.svc/ADD_HAA';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sHAAPHON: self.ruleForm.haaPHON,
									sHAAPSWD: this.$md5(self.ruleForm.haaPSWD),
									sHAADEFG: self.ruleForm.haaDEFG,
									sHAAPHID: self.ruleForm.haaPHID,
									sHAAWXID: self.ruleForm.haaWXID,
									sHAAAPID: self.ruleForm.haaAPID,
									sHAAPHOT: self.ruleForm.imgbase64,
									sHAANICK: self.ruleForm.haaNICK,
									sHAANAME: self.ruleForm.haaNAME,
									sHAAGSEX: self.ruleForm.haaGSEX,
									sHAABIRT: self.ruleForm.haaBIRT
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '添加家长失败', //新增失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('添加家长成功'); // 新增成功
										this.$router.push('/parentList') // 跳转路由
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "addParent") {
												indexs = i;
												break;
											}
										}

										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '添加家长请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '添加家长请求失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '提交失败', //表单验证失败
							type: 'error'
						});
					}
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addParent") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.font {
		font-size: 14px;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.avatar-uploader >>> .el-upload--text {
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 128px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 128px;
		height: 128px;
		text-align: center;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 16px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.avatar-uploader .el-upload {
		width: 128px;
		height: 128px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
